export default {
  namespaced: true,
  state: () => ({
    cliente: [],
    endereco: [],
    tiposDocumento: [],
    contatos: [],
    setIsLoading: false,
    setIsLoadingEndereco: false,
    setIsLoadingTiposDocumento: false,
    setIsLoadingContatos: false,
    requestChanges: false,

  }),
  actions: {},
  mutations: {
    SET_CLIENTE(state, data) {
      state.cliente = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },

    SET_IS_LOADING_ENDERECO(state, data) {
      state.setIsLoadingEndereco = data;
    },
    SET_IS_LOADING_TIPOS_DOCUMENTO(state, data) {
      state.setIsLoadingTiposDocumento = data;
    },

    SET_IS_LOADING_CONTATOS(state, data) {
      state.setIsLoadingContatos = data;
    },

    SET_REQUEST_CHANGES(state, data) {
      state.requestChanges = data;
    },
    SET_ENDERECO(state, data) {
      state.endereco = data;
    },
    SET_TIPOS_DOCUMENTO(state, data) {
      state.tiposDocumento = data;
    },
    SET_CONTATOS(state, data) {
      state.contatos = data;
    },

  },
  getters: {
    getCliente: (state) => state.cliente,
    getIsLoading: (state) => state.setIsLoading,
    getRequestChanges: (state) => state.requestChanges,
    getEndereco: (state) => state.endereco,
    getTiposDocumento: (state) => state.tiposDocumento,
    getContatos: (state) => state.contatos,
    getIsLoadingEndereco: (state) => state.setIsLoadingEndereco,
    getIsLoadingTiposDocumento: (state) => state.setIsLoadingTiposDocumento,
    getIsLoadingContatos: (state) => state.setIsLoadingContatos,
  },
};
